// extracted by mini-css-extract-plugin
module.exports = {"shareModal":"ShareModal_shareModal__kGP8y","social_link":"ShareModal_social_link__BGLSt","icon":"ShareModal_icon__IPOo7"};